const Genesis = require("../Genesis.js")
import { ScriptHelper, SwalHelper } from "../Helpers/helpers";
import { WorkflowHandler } from "../Workflow/WorkflowHandler";

export class ISiteMobileWorkOrderRiskAssessmentPage {
    constructor() { }
    public Init() {
        WorkflowHandler.InitWorkflowButtons();
        $("#raPassed").click(() => {            
            $("#isStartWorkNow").prop("checked", true);
        });

        $("#raNotRequired").click(() => {
            $("#isStartWorkNow").prop("checked", true);
        });

        $("#raFailed").click(() => {
            $("#isStartWorkNow").prop("checked", false);
        });

        $("#saveRiskAssessment").click((e) => {
            const form: HTMLFormElement | null = document.querySelector("#riskAssessmentForm");
            let isFormValid = false;
            if (form !== null) {
                if (!form.checkValidity()) {
                    form.classList.add('was-validated');
                }
                else {
                    isFormValid = true;
                }
            }

            if (isFormValid) {
                const isStartWorkNow: boolean = $("#isStartWorkNow").is(":checked");
                const isPassed: boolean = $("#raPassed").is(":checked");
                const isFailed: boolean = $("#raFailed").is(":checked");
                const isNotRequired: boolean = $("#raNotRequired").is(":checked");
                const recordId: number = $("#recordId").val() as number;

                if (isStartWorkNow) {
                    if (isPassed) {
                        WorkflowHandler.handleActionButton(e, recordId, "Start Work RA Passed", true);
                    }
                    else if (isFailed) {
                        WorkflowHandler.handleActionButton(e, recordId, "Risk Assessment Failed", true);
                    }
                    else if (isNotRequired) {
                        WorkflowHandler.handleActionButton(e, recordId, "Start Work - No RA", true);
                    }
                }

                if (!isStartWorkNow) {
                    if (isPassed) {
                        WorkflowHandler.handleActionButton(e, recordId, "Risk Assessment Passed", true);
                    }
                    else if (isFailed) {
                        WorkflowHandler.handleActionButton(e, recordId, "Risk Assessment Failed", true);
                    }
                    else if (isNotRequired) {
                        location.href = Genesis.url(`/WorkOrder/View?id=${recordId}`)
                    }
                }
            }
        })
    }
};